import { render, staticRenderFns } from "./ShareGoodsListDetail.vue?vue&type=template&id=5fad9d57&scoped=true"
import script from "./ShareGoodsListDetail.vue?vue&type=script&lang=ts"
export * from "./ShareGoodsListDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShareGoodsListDetail.vue?vue&type=style&index=0&id=5fad9d57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad9d57",
  null
  
)

export default component.exports